document.addEventListener('click', function (event) {
  const checkoutButton = event.target.closest('button[name="checkout"], input[name="checkout"]');

  if (!checkoutButton) return;

  let container = checkoutButton.closest(
    'cart-drawer, .cart-drawer, .drawer__footer, .cart__footer, .cart__blocks, .cart__ctas'
  );

  if (!container) {
    container = checkoutButton.parentElement;
  }

  let termsBox = container.querySelector('.infinite-terms-checkbox');

  if (!termsBox && container.parentElement) {
    termsBox = container.parentElement.querySelector('.infinite-terms-checkbox');
  }

  if (!termsBox) {
    const allTermsBoxes = Array.from(document.querySelectorAll('.infinite-terms-checkbox'));

    termsBox = allTermsBoxes.find((box) => {
      return box.offsetParent !== null && box.compareDocumentPosition(checkoutButton) & Node.DOCUMENT_POSITION_FOLLOWING;
    });
  }

  if (!termsBox) return;

  const checkbox = termsBox.querySelector('.terms-checkbox');
  const error = termsBox.querySelector('.terms-error');

  if (!checkbox || !error) return;

  if (!checkbox.checked) {
    event.preventDefault();
    event.stopPropagation();

    error.style.display = 'block';
    checkbox.classList.add('infinite-terms-checkbox-warning');

    termsBox.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });

    checkbox.focus();

    setTimeout(() => {
      checkbox.classList.remove('infinite-terms-checkbox-warning');
    }, 1200);
  }
});

document.addEventListener('change', function (event) {
  const checkbox = event.target.closest('.terms-checkbox');

  if (!checkbox) return;

  const termsBox = checkbox.closest('.infinite-terms-checkbox');
  const error = termsBox?.querySelector('.terms-error');

  if (checkbox.checked && error) {
    error.style.display = 'none';
  }
});